import { render } from "./StepFooter.vue?vue&type=template&id=74d857ae&scoped=true"
import script from "./StepFooter.vue?vue&type=script&lang=js"
export * from "./StepFooter.vue?vue&type=script&lang=js"

import "./StepFooter.vue?vue&type=style&index=0&id=74d857ae&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74d857ae"]])

export default __exports__